import ApiClient from './ApiClient';
import axios from 'axios';

class MeetingInvitesAPI extends ApiClient {
  constructor() {
    super('meeting_invites');
  }

  create(accountId, conversationId, accessToken) {
    const url = `/api/v1/accounts/${accountId}/conversations/${conversationId}/meeting_invites`;
    const headers = accessToken ? { api_access_token: accessToken } : {};
    return axios.post(url, {}, { headers });
  }
}

export default new MeetingInvitesAPI();
